<template>
    <div id="noteCard">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span id="title">{{title}}</span>
          <i class="el-icon-close" id="closeIcon" @click="onClose"></i>
        </div>
        <el-row
            v-for="(row,index) in list"
            :key="index"
        >
          <span class="content" v-if="!!row.label">{{`◆ ${row.label}:&nbsp;&nbsp;&nbsp;&nbsp;${row.value}`}}</span>
          <span class="content" v-if="!row.label">{{row}}</span>
        </el-row>

      </el-card>
    </div>
</template>

<script>
export default {
  name: "noteCard",
  props:['title','info'],
  data(){
    return {
      factor:2,
      list:[]
    }
  },
  methods:{
    onClose(){
      this.$emit('onClose',this.title);
    }
  },
  watch:{
    info:{
      immediate:true,
      handler(val){
        this.list = val?val:[];
      }
    },
  }
}
</script>

<style scoped>
.el-card{

}
.box-card{
  width: 280px;
  height: fit-content;
  min-height: 230px;
  background: #FEF9E3;
}
.image{
  width: 100%;
  display: block;
}

#closeIcon{
  padding: 0;
  float: right;
}
#closeIcon:hover{
  color: black;
  font-weight: bold;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}
#title{
  color:#2c2f3b;
}
#content{
  margin-bottom: 18px;
  font-size: 16px;
  color: rgba(45,45,45,.9);
}
</style>
